export default "__VITE_ASSET__VlpsWnJi__"